import React, { useContext, useEffect, useRef, useState } from 'react'
import ReactDom from 'react-dom'
import { useFireStore, useStorage, timestamp } from '../../firebase/firebase'
import { useTranslation } from "react-i18next";
import { AppState } from 'App';
import { useAuth } from 'context/AuthContext'
import { format } from 'date-fns'
import axios from 'axios'

import { Close } from 'components/misc/Icons'
import { Loading } from 'components/misc/Icons'

export default function ModalAddPost({open, onClose, latitude, longitude}) {

    const [appState, setAppState] = useContext(AppState)
    const {t, i18n} = useTranslation('common');

    // STATE FOR CITY AND WEATHER APIs
    const [city, setCity] = useState(null)
    const [weather, setWeather] = useState(null)

    const fileInput = useRef();
    const { currentUser } = useAuth()

    async function getCityData() {
        try {
            let data = await axios({
                method: 'get',
                url: 'https://us1.locationiq.com/v1/reverse.php?key=pk.55197923228b71565b71029e6d95b8a9&lat='+latitude+'&lon='+longitude+'&format=json'
            }).then(({data}) => data);
            setCity(data)
        }
        catch (err) {
            console.log(err)
        }
        finally {

        }
    }

    async function getWeatherData() {
        try {
            let data = await axios({
                method: 'get',
                url: 'https://api.openweathermap.org/data/2.5/weather?lat='+latitude+'&lon='+longitude+'&units=metric&appid=b4277e9cde17d9808798fb55d76a9e43'
            }).then(({data}) => data);
            setWeather(data)
        }
        catch (err) {
            console.log(err)
        }
        finally {

        }
    }

    useEffect(() => {
        getCityData();
        getWeatherData();
    },[latitude, longitude])

    // post State
    const [tag, setTag] = useState([]);
    const [post, setPost] = useState('')
    //const [file, setFile] = useState(null)

    const photoArray = [];

    function handleSubmit(e) {
        e.preventDefault();
        setAppState(prevState => ({...prevState,loadingContext:true}))
        const thisLatitude = latitude;
        const thisLongitude = longitude;
        const today = new Date();
        const todayFormatted = format(today, 'EEE LLL dd yyyy');
        const locationCity = city.address.city;
        const locationTown = city.address.village;
        const weatherDesc = weather.weather[0].description;
        const temperature = weather.main.temp;
        const weatherIcon = weather.weather[0].icon;
        const lowercaseTag = tag.toLowerCase();
        const order = appState.currentPost + 1;

        let fileArray = fileInput.current.files;
        const uploadTasks = [];
        for (let i = 0; i < fileArray.length; i++) {
            uploadTasks.push(handleUpload(fileArray[i]));
        }
        Promise.all(uploadTasks).then(() => {
            const collectionRef = useFireStore.collection('posts');
            collectionRef.add({
                tag: lowercaseTag,
                post: post,
                photos: photoArray,
                user: currentUser.uid,
                createdAt: timestamp(),
                latitude: thisLatitude,
                longitude: thisLongitude,
                date: todayFormatted,
                city: locationCity,
                town: locationTown,
                weather: weatherDesc,
                temperature: temperature,
                weatherIcon: weatherIcon,
                order:order
            });
        });
        setTag('')
        setPost('')
        setAppState(prevState => ({...prevState,loadingContext:null}))
        onClose();
    }

    // this is looped
    function handleUpload(file) {

        const storageRef = useStorage.ref();
        const fileRef = storageRef.child(file.name);

        return fileRef.put(file).then(() => {
            return fileRef.getDownloadURL().then(function (url) {
                photoArray.push(url);
            });
        });

    }

    if (!open) return null

    return ReactDom.createPortal(
        <div className="fixed top-0 bottom-0 left-0 right-0 z-1100" style={{backgroundColor: 'rgba(0, 0, 0, .7)'}}>
            <div className="fixed p-4 border rounded-lg border-borderlight dark:border-borderdark bg-bglight dark:bg-bgdark w-190 z-1100" style={{top: '50%',left: '50%',transform: 'translate(-50%, -50%)'}}>

                <div className="flex flex-row items-center justify-between h-10 mb-4">
                    <div>
                        <h2 className="text-lg font-bold text-textlight dark:text-textdark">{t('APtitle')}</h2>
                    </div>
                    <div>
                        <button onClick={onClose} className="flex items-center justify-center w-8 h-8 rounded-full bg-itemlight dark:bg-itemdark dark:text-textlight text-textlight dark:hover:text-textdark hover:bg-gray-300 focus:outline-none">
                            <Close/>
                        </button>
                    </div>
                </div>
                <div>
                    {/* main content here */}
                    <div className="w-full">

                        <form onSubmit={handleSubmit}>
                        <div className="shadow sm:overflow-hidden">
                            <div className="px-4 py-5 space-y-6 bg-bglight dark:bg-bgdark sm:p-6">
                                <div className="grid grid-cols-3 gap-6">
                                    <div className="col-span-3 sm:col-span-2">
                                        <label htmlFor="tag" className="block text-sm font-medium text-textlight dark:text-textdark">
                                        {t('APinput1title')}
                                        </label>
                                        <div className="flex mt-1 rounded-md shadow-sm">
                                            <span className="inline-flex items-center px-3 text-sm border border-r-0 border-borderlighthover rounded-l-md bg-bglight text-textlight dark:bg-itemdark dark:border-borderdark dark:text-textdark">
                                                #
                                            </span>
                                            <input value={tag} onChange={(e) => setTag(e.target.value)} type="text" id="tag" className="flex-1 block w-full rounded-none focus:ring-hoverlight focus:border-hoverlight rounded-r-md sm:text-sm dark:bg-itemdark dark:border-borderdark border-borderlighthover placeholder-textlight dark:placeholder-textdark" placeholder={t('APeg')}/>
                                        </div>
                                        <p className="mt-2 text-sm text-textlight dark:text-textdark">
                                            {t('APinput1help')}
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="about" className="block text-sm font-medium text-textlight dark:text-textdark">
                                        {t('APinput2title')}
                                    </label>
                                    <div className="mt-1">
                                        <textarea onChange={(e) => setPost(e.target.value)} value={post} id="about" name="about" rows="5" className="block w-full mt-1 rounded-md shadow-sm focus:ring-hoverlight focus:border-hoverlight sm:text-sm dark:bg-itemdark dark:border-borderdark border-borderlighthover placeholder-textlight dark:placeholder-textdark" placeholder={t('APinput2placeholder')}></textarea>
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-textlight dark:text-textdark">
                                        {t('APinput3title')}
                                    </label>
                                    <div className="flex justify-center px-6 pt-5 pb-6 mt-2 border-2 border-dashed rounded-md border-borderlighthover dark:border-borderdark">
                                        <div className="space-y-1 text-center">
                                            <svg className="w-12 h-12 mx-auto text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <div className="flex text-sm text-gray-600">
                                                <label htmlFor="file-upload" className="relative font-medium cursor-pointer text-textlight dark:text-textdark hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                <span>{t('APinput3help1')}</span>
                                                <input ref={fileInput} accept="image/x-png,image/jpeg" id="file-upload" name="file-upload" type="file" className="sr-only" multiple/>
                                                </label>
                                                <p className="pl-1 text-textlight dark:text-textdark">{t('APinput3help2')}</p>
                                            </div>
                                            <p className="text-xs text-textlight dark:text-textdark">
                                                {t('APinput3help3')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-3 text-right sm:px-6">
                                <button
                                    type="submit"
                                    className="inline-flex justify-center px-4 py-2 text-sm font-medium transition-colors duration-200 border border-transparent rounded-md shadow-sm text-textlight dark:text-textdark bg-itemlight dark:bg-itemdark hover:bg-hoverlight focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:hover:bg-hoverlight hover:text-white dark:hover:text-white border-borderlighthover dark:border-borderdark">
                                    <span className="">{t('APpost')}</span> {appState.loadingContext===true ? <Loading width={4} height={4} stroke={3} /> : null}
                                </button>
                            </div>
                        </div>
                        </form>

                    </div>

                </div>

            </div>
        </div>,
        document.getElementById('portal')
    )
}

